import { Component, Input, isDevMode } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Clinic } from '@models/clinic';

@Component({
  selector: 'app-org-portal-style-preview',
  templateUrl: './org-portal-style-preview.component.html',
  styleUrls: ['./org-portal-style-preview.component.less'],
})
export class OrgPortalStylePreviewComponent {
  portalUrl: SafeUrl;
  @Input() set clinic(clinic: Clinic) {
    let origin = location.origin;
    const idx = origin.indexOf(':4200');
    if (isDevMode() && idx >= 0) {
      origin = origin.substring(0, idx) + ':4201';
    }
    // Apply dummy var to force reload
    const url = origin + '/portal?reloadVar=' + new Date().getTime();
    this.portalUrl = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  constructor(private sanitizer: DomSanitizer) {}
}
